export default function (filename) {
  return filename.split('.').pop() || '';
}
